import { useState, useEffect, useCallback } from 'react';
import useDebounce from '../../context/hooks/useDebounce';
import { Table, Form, InputGroup, Row, Col, Spinner } from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import ExcelClients from './ExcelClients';
import PermissionWrapper from '../../context/PermissionWrapper';
import '../../appstyles/ClientsCSS/ClientsList.css';

const ClientList = () => {
  const axiosInstance = useAxiosPrivate();
  const [clients, setClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchClients = useCallback((page, searchQuery, pageSize) => {
    setLoading(true)
    const url = searchQuery
      ? `api/client/?page=${page}&size=${pageSize}&client_name=${searchQuery}`
      : `api/client/?page=${page}&size=${pageSize}`;

    axiosInstance.get(url)
      .then(response => {
        setClients(response.data);
        setTotalPages(response.data.totalPages);
      })
      .catch(error => {
        console.log('Failed to fetch clients', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance]);

  useEffect(() => {
    fetchClients(currentPage, debouncedSearch, rowsPerPage);
  }, [currentPage, debouncedSearch, rowsPerPage, fetchClients]);

  // ...existing code...

  // Use backend results directly

  const handleRowClick = (clientId) => {
    navigate(`/client/details/${clientId}`);
  };

   // Handle page change
   const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination handled by ListPaginator

  return (
    <div className='maestros-list'>
    <h2>Lista de Clientes</h2>
    <hr />

    <Row style={{ alignItems: 'center', marginBottom: '1rem' }}>
      <Col md={6}>
        <Form inline style={{ width: '100%' }} onSubmit={(e) => e.preventDefault()}>
          <InputGroup>
            <Form.Control
              type="search"
              placeholder="Buscar por nombre de cliente"            
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Form>
      </Col>
    </Row>

    {loading ? ( 
      <div className='loading-container'>
      <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
      <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
      </div>
    ) : (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre Cliente</th>
          <th>Sector</th>
          <th>Teléfono</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
  {clients.data && clients.data.map(client => (
          <tr key={client.client_id} onClick={() => handleRowClick(client.client_id)} style={{ cursor: 'pointer' }}>
            <td>{client.client_id}</td>
            <td>{client.client_name}</td>
            <td>{client.client_sector}</td>
            <td>{client.phone}</td>
            <td>{client.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    )}

    <Row>
      <Col
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <PermissionWrapper feature="cliente" action="excel">
          <ExcelClients/>
        </PermissionWrapper>
      </Col>

      <Col style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row>
    </div>
  );
};

export default ClientList;